"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Masonry = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var masonry_layout_1 = __importDefault(require("masonry-layout"));
var Masonry = /** @class */ (function (_super) {
    __extends(Masonry, _super);
    function Masonry() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.erd = undefined;
        _this.latestKnownDomChildren = [];
        _this.displayName = "MasonryComponent";
        _this.imagesLoadedCancelRef = undefined;
        _this.setRef = function (n) {
            _this.masonryContainer = n;
        };
        _this.diffDomChildren = function () {
            var forceItemReload = false;
            var knownChildrenStillAttached = _this.latestKnownDomChildren.filter(function (element) {
                /*
                 * take only elements attached to DOM
                 * (aka the parent is the masonry container, not null)
                 * otherwise masonry would try to "remove it" again from the DOM
                 */
                return !!element.parentNode;
            });
            /*
             * If not all known children are attached to the dom - we have no other way of notifying
             * masonry to remove the ones not still attached besides invoking a complete item reload.
             * basically all the rest of the code below does not matter in that case.
             */
            if (knownChildrenStillAttached.length !== _this.latestKnownDomChildren.length) {
                forceItemReload = true;
            }
            var currentDomChildren = _this.getCurrentDomChildren();
            /*
             * Since we are looking for a known child which is also attached to the dom AND
             * not attached to the dom at the same time - this would *always* produce an empty array.
             */
            var removed = knownChildrenStillAttached.filter(function (attachedKnownChild) {
                return !~currentDomChildren.indexOf(attachedKnownChild);
            });
            /*
             * This would get any children which are attached to the dom but are *unkown* to us
             * from previous renders
             */
            var newDomChildren = currentDomChildren.filter(function (currentChild) {
                return !~knownChildrenStillAttached.indexOf(currentChild);
            });
            var beginningIndex = 0;
            // get everything added to the beginning of the DOMNode list
            var prepended = newDomChildren.filter(function (newChild) {
                var prepend = beginningIndex === currentDomChildren.indexOf(newChild);
                if (prepend) {
                    // increase the index
                    beginningIndex++;
                }
                return prepend;
            });
            // we assume that everything else is appended
            var appended = newDomChildren.filter(function (el) {
                return prepended.indexOf(el) === -1;
            });
            // get everything added to the end of the DOMNode list
            var moved = [];
            /*
             * This would always be true (see above about the lofic for "removed")
             */
            if (removed.length === 0) {
                /*
                 * 'moved' will contain some random elements (if any) since the "knownChildrenStillAttached" is a filter
                 * of the "known" children which are still attached - All indexes could basically change. (for example
                 * if the first element is not attached)
                 * Don't trust this array.
                 */
                moved = knownChildrenStillAttached.filter(function (child, index) {
                    return index !== currentDomChildren.indexOf(child);
                });
            }
            _this.latestKnownDomChildren = currentDomChildren;
            return {
                old: knownChildrenStillAttached,
                new: currentDomChildren,
                removed: removed,
                appended: appended,
                prepended: prepended,
                moved: moved,
                forceItemReload: forceItemReload
            };
        };
        _this.performLayout = function () {
            var diff = _this.diffDomChildren();
            var reloadItems = diff.forceItemReload || diff.moved.length > 0;
            // Would never be true. (see comments of 'diffDomChildren' about 'removed')
            if (diff.removed.length > 0) {
                if (_this.props.enableResizableChildren) {
                    diff.removed.forEach(_this.erd.removeAllListeners, _this.erd);
                }
                _this.masonry.remove(diff.removed);
                reloadItems = true;
            }
            if (diff.appended.length > 0) {
                _this.masonry.appended(diff.appended);
                if (diff.prepended.length === 0) {
                    reloadItems = true;
                }
            }
            if (diff.prepended.length > 0) {
                _this.masonry.prepended(diff.prepended);
            }
            if (reloadItems) {
                _this.masonry.reloadItems();
            }
            _this.masonry.layout();
        };
        _this.getCurrentDomChildren = function () {
            var node = _this.masonryContainer;
            if (!node)
                return;
            var children = _this.props.options.itemSelector
                ? node.querySelectorAll(_this.props.options.itemSelector)
                : node.children;
            return Array.prototype.slice.call(children);
        };
        _this.initializeMasonry = function (force) {
            if (!_this.masonry || force) {
                _this.masonry = new masonry_layout_1.default(_this.masonryContainer, _this.props.options);
                if (_this.props.onLayoutComplete) {
                    _this.masonry.on("layoutComplete", _this.props.onLayoutComplete);
                }
                if (_this.props.onRemoveComplete) {
                    _this.masonry.on("removeComplete", _this.props.onRemoveComplete);
                }
                _this.latestKnownDomChildren = _this.getCurrentDomChildren();
            }
        };
        return _this;
    }
    Masonry.prototype.componentDidMount = function () {
        var _this = this;
        setTimeout(function () {
            _this.initializeMasonry();
        }, 300);
    };
    Masonry.prototype.componentDidUpdate = function () {
        if (this.masonry) {
            this.performLayout();
        }
    };
    Masonry.prototype.componentWillUnmount = function () {
        // unregister events
        if (this.props.onLayoutComplete && this.masonry) {
            this.masonry.off("layoutComplete", this.props.onLayoutComplete);
        }
        if (this.props.onRemoveComplete && this.masonry) {
            this.masonry.off("removeComplete", this.props.onRemoveComplete);
        }
        this.masonry && this.masonry.destroy();
    };
    Masonry.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)("ul", __assign({ ref: this.setRef }, { children: this.props.children }));
    };
    return Masonry;
}(react_1.default.Component));
exports.Masonry = Masonry;
